import axios from "axios";

// ARB-9910 — banner notifications for the Vue (Billing Pro / 3.0) app.
const bannersService = {
  // GET /plapi/banners — active, Billing-Pro-targeted banners (newest first).
  // The bearer token + baseURL are applied by the global axios interceptors (see pl.service.js).
  async getActiveBanners() {
    const { data } = await axios.get(`/plapi/banners`);
    return data;
  },
};

export default bannersService;
